import axiosInstance from './axiosInstance';

export const getSystemBaseItemList = async () => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBaseItem/List`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemCoolItemList = async () => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemCoolItem/List`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemTestItemList = async () => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemTestItem/List`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildbyId = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBuild/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildbySoId = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBuild/So/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildbySoPartId = async (so_part_id) => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBuild/SoPart/${so_part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildItembyId = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBuildItem/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildItembySystemId = async (system_id) => {
  try {
    const { data } = await axiosInstance.get(`/SystemBuildSheet/SystemBuildItem/System/${system_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSystemBuildItembySoPartId = async (so_part_id) => {
  try {
    const { data } = await axiosInstance.get(`/SaleOrder/SystemBuild/${so_part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const CreateSystemBuildApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/SystemBuildSheet/SystemBuild`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSystemBuildApi = async (id, formData) => {
  try {
    const { data } = await axiosInstance.put(`/SystemBuildSheet/SystemBuild/${id}`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DeleteSystemBuildApi = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/SystemBuildSheet/SystemBuild/${id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
